import React from "react";
import { CartContext, SOCartCtx } from "./cart-context";
import { either } from "fp-ts";
import { useCart } from "../../domain/cart/hooks/useCart";
import { pipe } from "fp-ts/lib/function";
import { LocaleSegmentContext } from "../page-context";

const loadingCart: SOCartCtx = {
  cart: either.left("loading-cart"),
};

const shoppingCurrentlyNotPossible: SOCartCtx = {
  cart: either.left("shopping-currently-not-possible"),
};

const shoppingNotPossible: SOCartCtx = {
  cart: either.left("shopping-not-possible"),
};

export const CartAspect: React.FC<React.PropsWithChildren<{
  localeSegmentCtx: LocaleSegmentContext;
  recoverCartId: string | null;
}>> = props => {
  const cart = useCart(props.localeSegmentCtx, props.recoverCartId);

  function getContextValue(): SOCartCtx {
    switch (cart.__tag) {
      case "error": {
        return shoppingCurrentlyNotPossible;
      }
      case "loading": {
        return loadingCart;
      }
      case "idle": {
        return loadingCart;
      }
      case "loaded": {
        return pipe(
          cart.data,
          either.fold(
            err => {
              if (err === "unauthorised") {
                return shoppingCurrentlyNotPossible;
              } else if (err === "shopping-currently-not-possible") {
                return shoppingCurrentlyNotPossible;
              } else {
                return shoppingNotPossible;
              }
            },
            cartState => {
              return {
                cart: either.right(cartState),
              };
            },
          ),
        );
      }

      default: {
        const _: never = cart;
        return _;
      }
    }
  }

  const value = getContextValue();

  return (
    <CartContext.Provider value={value}>
      <>{props.children}</>
    </CartContext.Provider>
  );
};
